import React from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import { FaExchangeAlt, FaPaperclip, FaTrash } from 'react-icons/fa';
import Loading from '~/Components/Loading';
import CardPendencias from './CardPendencias';

const ModalAcoes = ({
  show,
  onHide,
  contrato,
  detalhe,
  loadingDetalhe,
  onMudarFase,
  onAnexar,
  onExcluir,
  onSalvoPendencias,
  podeMudarFase,
  podeExcluir,
}) => {
  if (!contrato) return null;

  const itens = detalhe && detalhe.itens ? detalhe.itens : [];

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="h6 mb-0">
          Ações — Boleto {contrato.boleto} / Conta {contrato.conta}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex mb-3">
          {podeMudarFase && (
            <Button variant="primary" className="mr-2" onClick={onMudarFase}>
              <FaExchangeAlt className="mr-2" /> Mudar Fase
            </Button>
          )}
          <Button variant="info" className="mr-2" onClick={onAnexar}>
            <FaPaperclip className="mr-2" /> Anexar Documentos
          </Button>
          {podeExcluir && (
            <Button variant="danger" onClick={onExcluir}>
              <FaTrash className="mr-2" /> Excluir
            </Button>
          )}
        </div>

        <Card className="mb-3">
          <Card.Header className="py-2">
            <strong>Histórico de Mudanças</strong>
          </Card.Header>
          <Card.Body className="p-0" style={{ maxHeight: 260, overflowY: 'auto' }}>
            {loadingDetalhe && <Loading />}
            {!loadingDetalhe && itens.length === 0 && (
              <p className="text-muted text-center my-3 small">
                Nenhuma mudança registrada para este contrato.
              </p>
            )}
            {!loadingDetalhe && itens.length > 0 && (
              <table className="table table-sm table-striped table-bordered mb-0">
                <thead style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                  <tr>
                    <th>Data</th>
                    <th>Título</th>
                    <th>Observação</th>
                    <th>Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {itens.map((item, idx) => (
                    <tr key={`${item.data_item}-${item.titulo}-${idx}`}>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {item.data_item
                          ? new Date(item.data_item).toLocaleDateString('pt-BR')
                          : '-'}
                      </td>
                      <td>{item.titulo}</td>
                      <td>{item.observacao || '-'}</td>
                      <td>{item.usuario || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Body>
        </Card>

        <CardPendencias
          contrato={contrato}
          detalhe={detalhe}
          onSalvo={onSalvoPendencias}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ModalAcoes;
